import { render, staticRenderFns } from "./UnionMemberSelection.vue?vue&type=template&id=6efc7190&"
import script from "./UnionMemberSelection.vue?vue&type=script&lang=js&"
export * from "./UnionMemberSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports